import axios from "axios"
import { API_URL } from "./consts"

const axiosInstance = axios.create({
    // baseURL: "https://us-central1-dri-impianti-733de.cloudfunctions.net/api/v1",
    baseURL: API_URL
})

export default axiosInstance
